<igx-grid #gridEmpresas [width]="'100%'" [height]="'100%'" [locale]="localGrid"
  [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [rowSelection]="activarBotones ? rowSelectionSingle : rowSelectionMultiple" [selectRowOnClick]="false" [sortingOptions]="sortingOptions"
  [rowEditable]="true" [primaryKey]="'IdEmpresa'" (rowEditEnter)="rowEditEnter()" (rowEditExit)="rowEditExit()"
  (rowEditDone)="addUpdateEmpresa($event)" (rowEdit)="validarEmpresa($event)" (contextMenu)="menuContextual($event)" (window:click)="disableContextMenu()"
  [igxGridState]="optionsGridLocal" (columnInit)="onColumnInit($event)" [moving]="true" (keydown)="customKeydown($event)" paste-handler-neodata (onDataProcessed)="datosPegadosDesdeExcel($event)"
          (rowSelectionChanging)="handleRowSelection()">
  <igx-grid-toolbar>
    <igx-grid-toolbar-title>
      <app-filtro-general-moderno #filtroGeneral descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}" (enterPalabra)="filterInput($event)" (limpiarPalabras)="clearInput()" />
    </igx-grid-toolbar-title>
    <igx-grid-toolbar-actions>
      <igx-grid-toolbar-hiding />
      <igx-grid-toolbar-pinning />
      <app-mas-opciones-grid #masOpcionesG [arrayDatosAVer]="[0, 1, 2, 3, 6]" (opcionSeleccionada)="onSelectionDropDown($event)" />
    </igx-grid-toolbar-actions>
  </igx-grid-toolbar>
  <ng-template igxSortHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortAscendingHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortDescendingHeaderIcon>
    <igx-icon>south</igx-icon>
  </ng-template>
  <ng-template igxExcelStyleHeaderIcon>
    <igx-icon>filter_alt</igx-icon>
  </ng-template>
  <igx-column field="Empresa" header="{{ 'GRIDS.EMPRESA.COL_EMPRESA' | translate}}" [dataType]="'string'" width="150px" [sortable]="true" [resizable]="true" [hasSummary]="true" [summaries]="'filasSummary' | summaryPipeNeo">
    <ng-template igxHeader #empresaHeaderTemplate let-column>
      <div title="{{ 'GRIDS.EMPRESA.COL_EMPRESA' | translate}}" class="header-required">{{column.header + '*'}}</div>
    </ng-template>
    <ng-template igxCellEditor #empresaEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="Empresa" [(ngModel)]="cell.editValue" uppercase [igxTextSelection]="true" [igxFocus]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="20"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="RazonSocialEmpresa" header="{{ 'GRIDS.EMPRESA.COL_RS' | translate}}" [dataType]="'string'" width="150px" [sortable]="true" [resizable]="true">
    <ng-template igxHeader #razonSocialEmpresaHeaderTemplate let-column>
      <div title="{{ 'GRIDS.EMPRESA.COL_RS' | translate}}" class="header-required">{{column.header + '*'}}</div>
    </ng-template>
    <ng-template igxCellEditor #razonSocialEmpresaEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="RazonSocialEmpresa" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="100"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  @if (false) {
    <igx-column field="IdCiudadEmpresa" [disableHiding]="true" />
  }
  <igx-column field="DescripcionCiudad" header="{{ 'GRIDS.EMPRESA.COL_CIUDAD' | translate}}" [dataType]="'string'" width="220px" [sortable]="true" [resizable]="true">
    <ng-template igxCellEditor #descripcionCiudadEditorTemplate let-cell="cell">
      <igx-input-group>
        <input #inputDescripcionCiudad igxInput name="DescripcionCiudad" type="text" [(ngModel)]="cell.editValue" uppercase [readOnly]="true"
               (keydown)="stopPropagationPegado($event)"/>
        <igx-suffix>
          <button title="{{ 'MENSAJES.GRALS.BUSCAR_REGISTRO_CATALOGO' | translate }}" igxButton="contained" (buttonClick)="onOpenDesCiudad(inputDescripcionCiudad, cell.row.data)">
            <igx-icon>search</igx-icon>
          </button>
        </igx-suffix>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="DireccionEmpresa" header="{{ 'GRIDS.EMPRESA.COL_DIRECCION' | translate}}" [dataType]="'string'" width="220px" [sortable]="true" [resizable]="true">
    <ng-template igxCellEditor #direccionEmpresaEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="DireccionEmpresa" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="80"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="Colonia" header="{{ 'GRIDS.EMPRESA.COL_COLONIA' | translate}}" [dataType]="'string'" width="150px" [sortable]="true" [resizable]="true">
    <ng-template igxCellEditor #coloniaEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="Colonia" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="30"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  @if (false) {
    <igx-column field="IdResponsableEmpresa" [disableHiding]="true" />
  }
  <igx-column field="NombreResponsable" header="{{ 'GRIDS.EMPRESA.COL_RESPONSABLE' | translate}}" [dataType]="'string'" width="150px" [sortable]="true" [resizable]="true">
    <ng-template igxCellEditor #nombreResponsableEditorTemplate let-cell="cell">
      <igx-input-group>
        <input #inputNombreResponsable igxInput name="NombreResponsable" type="text" [(ngModel)]="cell.editValue" uppercase [readOnly]="true"
               (keydown)="stopPropagationPegado($event)"/>
        <igx-suffix>
          <button title="{{ 'MENSAJES.GRALS.BUSCAR_REGISTRO_CATALOGO' | translate }}" igxButton="contained" (buttonClick)="onOpenRes(inputNombreResponsable, cell.row.data)">
            <igx-icon>search</igx-icon>
          </button>
        </igx-suffix>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="TelefonoEmpresa" header="{{ 'GRIDS.EMPRESA.COL_TELEFONO' | translate}}" [dataType]="'string'" width="110px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #telefonoEmpresaEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="TelefonoEmpresa" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="30"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="RfcEmpresa" header="RFC" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #rfcEmpresaEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="RfcEmpresa" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="13"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="CodigoPostalEmpresa" header="{{ 'GRIDS.EMPRESA.COL_CP' | translate}}" [dataType]="'string'" width="140px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #cpEmpresaEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="CodigoPostalEmpresa" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="6"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="CMICEmpresa" header="CMIC" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true" [hidden]="true" >
    <ng-template igxCellEditor #cMICEmpresaEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="CMICEmpresa" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="40"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="FaxEmpresa" header="Fax" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true" [hidden]="true" >
    <ng-template igxCellEditor #faxEmpresaEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="FaxEmpresa" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="30"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="IMSSEmpresa" header="IMSS" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true" [hidden]="true" >
    <ng-template igxCellEditor #iMSSEmpresaEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="IMSSEmpresa" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="10"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="InfonavitEmpresa" header="Infonavit" [dataType]="'string'" width="110px" [sortable]="true" [resizable]="true" [hidden]="true" >
    <ng-template igxCellEditor #infonavitEmpresaEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="InfonavitEmpresa" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="20"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="MailEmpresa" header="Mail" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true" [hidden]="true" >
    <ng-template igxCellEditor #mailEmpresaEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="MailEmpresa" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="50"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="SitioWeb" header="{{ 'GRIDS.EMPRESA.COL_SITIO_WEB' | translate}}" [dataType]="'string'" width="350px" [sortable]="true" [resizable]="true" [hidden]="true" >
    <ng-template igxCellEditor #sitioWebEditorTemplate let-cell="cell">
      <igx-input-group>
        <input #sitioWeb igxInput name="SitioWeb" type="url" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true" (keydown)="stopPropagationPegado($event)"  maxlength="200"/>
        @if ((cell.editValue || cell.editValue === '0')) {
          <igx-suffix (click)="cell.editValue = ''">
            <button title="{{ 'TOOLTIPS.LIMPIAR_FILTRO' | translate }}" igxIconButton="contained" igxRipple>
              <igx-icon>clear</igx-icon>
            </button>
          </igx-suffix>
        }
        <igx-suffix style="padding-top: 6px !important;">
          <app-btn-url-contenido [valor]="sitioWeb.value" [archivoValido]="sitioWeb.validity.valid" />
        </igx-suffix>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <!--Acciones Editar, Agregar y Borrar-->
  @if (showActionStrip) {
    <igx-action-strip #actionstrip>
      <button title="{{ 'TOOLTIPS.NUEVO_REGISTRO' | translate}}" igxButton="fab" style="margin-right: 5px" (buttonClick)="accionStripRowBtn(actionstrip.context, 1)">
        <igx-icon>add</igx-icon>
      </button>
      <button title="{{ 'TOOLTIPS.EDITAR_REGISTRO' | translate}}" igxButton="fab" igxRipple style="margin-right: 5px" (buttonClick)='startEdit(actionstrip.context)'>
        <igx-icon>edit</igx-icon>
      </button>
      <button title="{{ 'TOOLTIPS.BORRAR_REGISTRO' | translate}}" igxButton="fab" (buttonClick)="accionStripRowBtn(actionstrip.context, 2)">
        <igx-icon >delete</igx-icon>
      </button>
    </igx-action-strip>
  }
</igx-grid>
@if (verContextMenu) {
  <app-context-menu-generico [cellMenuContextual]="cellMenuContextaul" [menusOpciones]="menus" [lengthMenu]="lengthMenu" [size]="sizeMenu" [subMenusOpciones]="subMenusOpciones"
                             (accionSeleccionada)="accionSeleccionada($event)" [x]="contextmenuX" [y]="contextmenuY" />
}
